export function Placeholder({ title, phase }: { title: string; phase: string }) {
  return (
    <div>
      <h1>{title}</h1>
      <div className="card">
        <span className="pill pill-counting">{phase}</span>
        <p className="muted" style={{ marginTop: 12 }}>
          This screen is part of the build and will be wired up in {phase}. The Phase&nbsp;1 scaffold
          establishes the workspace, auth, roles, schema, theme and project pipeline first.
        </p>
      </div>
    </div>
  );
}
